<template>
    <div class="d-flex justify-content-end border border-2 fixed-top-right px-3 mb-4" :class="(this.white) ?'bg-white' :'bg-dark'">
        {{ formattedTime }}
    </div>   
</template>
<script>
export default {
    name: 'timer',
    props:{
        formattedTime: { required: true },
    },
    data(){
        return {
            white : true
        }
    },
    watch:{
        "formattedTime"(){
            this.white = !this.white
        }
    }
}
</script>
<style scoped>
.fixed-top-right {
  z-index: 50;
  position: fixed;
  right: 0;
  top: 10;
}

</style>